module.exports = __webpack_public_path__ + "24e004ab/img/link-icon.fa09ed66.svg";